import React from 'react';
import cn from 'classnames';
import ShopMyDMUsers from './ShopMyDMUsers';
import ShopMyDMAnalytics from './ShopMyDMAnalytics';
import { useSearchParamsState } from '../../hooks/useSearchParamsState';
import './ShopMyDM.scss';

const URL_DEFAULTS = { tab: 'users', User_id: '', outcome: '', range: '' };

const ShopMyDM = () => {
  const [urlState, patchUrl] = useSearchParamsState(URL_DEFAULTS);
  const tab = urlState.tab === 'analytics' ? 'analytics' : 'users';
  const User_id = urlState.User_id || null;
  const outcome = urlState.outcome || null;
  const range = urlState.range || null;

  const onOpenCreator = (id, nextOutcome, nextRange) => {
    patchUrl({ tab: 'users', User_id: String(id), outcome: nextOutcome || null, range: nextRange || null });
  };

  return (
    <div className='shopmy-dm'>
      <div className='title-row'>
        <h1>ShopMy DM</h1>
        <div className='tabs'>
          <button type='button' className={cn('tab', { on: tab === 'users' })} onClick={() => patchUrl({ tab: 'users' })}>Users</button>
          <button type='button' className={cn('tab', { on: tab === 'analytics' })} onClick={() => patchUrl({ tab: 'analytics' })}>Analytics</button>
        </div>
      </div>
      {tab === 'users' ? (
        <ShopMyDMUsers key={`${User_id || ''}-${outcome || ''}-${range || ''}`} User_id={User_id} outcome={outcome} range={range} onOpenCreator={onOpenCreator} />
      ) : (
        <ShopMyDMAnalytics onOpenCreator={onOpenCreator} />
      )}
    </div>
  );
};

export default ShopMyDM;
